import classNames from 'classnames'
import { FC, memo } from 'react'
import { isWeekend } from 'utils/date'

type DataCellProps = React.PropsWithChildren<{
  data: {
    startDate: Date
  }
}>

// Custom template for table cells on Scheduler
export const DataCell: FC<DataCellProps> = memo((props) => {
  return (
    <div
      className={classNames(
        'w-full h-full',
        // Make the background color for the cell of weekend is gray
        isWeekend(props.data.startDate) && 'crew-scheduler-weekend'
      )}
    >
      {props.data.startDate.getDate()}
    </div>
  )
})
